import React from "react"
import { useTranslation } from "react-i18next"
import { Message } from "../components/Message"
import { ErrorDto } from "../models/Validation"
import { groupBy } from "../Utils"
import { TFunction } from "i18next"

interface ValidierungViewProps {
    messages: ErrorDto[]
}

export const ValidierungView: React.FC<ValidierungViewProps> = ({ messages }): React.JSX.Element | null => {
    const alertClasses = { SEVERITY_FATAL_ERROR: "danger", SEVERITY_ERROR: "danger", SEVERITY_WARNING: "warning", SEVERITY_INFORMATION: "info" }
    const alertClassesMap = new Map(Object.entries(alertClasses))
    const { t } = useTranslation()

    const groupBySeverity = messages ? groupBy("severity")(messages) : undefined
    return (
        <>
            {groupBySeverity
                ? Object.keys(groupBySeverity).map((severity, i) => {
                      const alertClass = alertClassesMap.get(severity)
                      const errorDto = groupBySeverity[severity] as ErrorDto[]
                      return (
                          <div key={i} className={`alert alert-${alertClass}`} role="alert" data-sort={Object.keys(alertClasses).indexOf(severity)}>
                              <SeverityHeader severity={severity} t={t} />
                              {errorDto.map((value, index) => (
                                  <Message message={t(value.code)} key={index} />
                              ))}
                          </div>
                      )
                  })
                : null}
        </>
    )
}

const SeverityHeader: React.FC<{ severity: string; t: TFunction }> = ({ severity, t }): React.JSX.Element | null => {
    switch (severity) {
        case "SEVERITY_FATAL_ERROR":
            return <h4 className="alert-heading">{t("validierung.fatalError")}</h4>
        case "SEVERITY_ERROR":
            return <h4 className="alert-heading">{t("validierung.error")}</h4>
        case "SEVERITY_WARNING":
            return <h4 className="alert-heading">{t("validierung.warning")}</h4>
        default:
            return null
    }
}
